// Mock data for Prysh AI website

export const heroContent = {
  headline: "Hyper-Realistic AI Videos at Unprecedented Scale",
  subheadline: "The Content Engine for Consumer Brands",
  supportingText: "Generate studio-quality promotional videos in minutes, not months. Built for speed, designed for scale, engineered for realism."
};

export const aboutContent = {
  title: "About Prysh AI",
  description: "Founded in 2026, Prysh AI emerged from a singular vision: to revolutionize how brands create visual content. We believed that hyper-realistic promotional media shouldn't require massive budgets, months of production, or armies of creators.",
  mission: "Today, we're building the infrastructure that enables businesses worldwide to achieve what was once impossible — content production velocity, scale, and cinematic quality, all at once. We're not just another AI tool. We're the creative backbone for the next generation of consumer brands."
};

export const whatWeDoContent = {
  title: "What We Do",
  subtitle: "AI-Powered Content Generation for Every Channel",
  description: "We produce hyper-realistic, brand-specific video content that performs. From product showcases to category campaigns, our AI generates visual assets that convert.",
  useCases: [
    {
      id: 1,
      title: "E-Commerce Marketplaces",
      description: "Dynamic product videos optimized for Amazon, Flipkart, and global marketplaces."
    },
    {
      id: 2,
      title: "D2C Websites",
      description: "Branded content that tells your product story with cinematic precision."
    },
    {
      id: 3,
      title: "Social Media & Paid Ads",
      description: "Scroll-stopping content engineered for Instagram, TikTok, and performance marketing."
    }
  ]
};

export const howWeDoItContent = {
  title: "How We Do It",
  subtitle: "Enterprise-Grade AI Infrastructure",
  description: "Prysh AI isn't a tool — it's a content engine. Our platform combines pre-designed AI workflows, API-driven automation, and high-GPU compute infrastructure to deliver end-to-end content pipelines.",
  capabilities: [
    {
      id: 1,
      title: "Pre-Designed AI Workflows",
      description: "Battle-tested templates for every content scenario"
    },
    {
      id: 2,
      title: "API-Driven Automation",
      description: "Seamless integration with your existing stack"
    },
    {
      id: 3,
      title: "High-GPU Compute",
      description: "Rendering power that matches your ambition"
    },
    {
      id: 4,
      title: "End-to-End Pipeline",
      description: "From brief to delivery, fully automated"
    }
  ]
};

export const whyPryshContent = {
  title: "Why Prysh AI",
  subtitle: "The Competitive Edge Your Brand Deserves",
  pillars: [
    {
      id: 1,
      title: "Speed",
      description: "From concept to content in hours, not weeks.",
      metric: "100x",
      metricLabel: "Faster Production"
    },
    {
      id: 2,
      title: "Scale",
      description: "Generate thousands of variations without creative fatigue.",
      metric: "10K+",
      metricLabel: "Videos Monthly"
    },
    {
      id: 3,
      title: "Realism",
      description: "Cinematic quality that rivals professional studios.",
      metric: "4K",
      metricLabel: "Ultra HD Output"
    },
    {
      id: 4,
      title: "Efficiency",
      description: "Reduce content costs while maximizing output quality.",
      metric: "90%",
      metricLabel: "Cost Reduction"
    }
  ]
};

export const navigationLinks = [
  { id: 1, label: "About", href: "#about" },
  { id: 2, label: "What We Do", href: "#what-we-do" },
  { id: 3, label: "How It Works", href: "#how-it-works" },
  { id: 4, label: "Why Prysh", href: "#why-prysh" }
];

export const footerContent = {
  companyName: "Prysh AI Private Limited",
  tagline: "The Content Engine for Consumer Brands",
  copyright: "© 2026 Prysh AI Private Limited. All rights reserved.",
  links: [
    { id: 1, label: "Privacy Policy", href: "#" },
    { id: 2, label: "Terms of Service", href: "#" },
    { id: 3, label: "Contact", href: "#" }
  ]
};
